<!-- <div
	class="card mb-3 h-20 border border-2 rounded bg-light"
	[ngClass]="'box-border-color-' + borderColorId"
>
	<div class="row h-100 text-center d-flex align-items-center">
		<div class="row fs-2 fw-bold mb-0">
			<div class="col-12">{{ value }}{{ units }}</div>
		</div>
		<div class="row">
			<p class="card-text m-0 fs-4">{{ title }}</p>
			<span class="card-text fs-4">{{ subtitle }}</span>
		</div>
	</div>
</div> -->

<div
	class=" h-20 border border-2 rounded bg-light"
	[ngClass]="'box-border-color-' + borderColorId"
>
	<div class=" h-100 text-center d-flex align-items-center">
		<div class="row">
			<p class="theme-main-color fw-bold fs-4">{{ units }} {{ title }} {{ value }}</p>
			<span class="card-text fs-4">{{ subtitle }}</span>
		</div>
	</div>
</div>
